<div class="pricing">

  <!-- ── Header ──────────────────────── -->
  <div class="pricing__header">
    <h1 class="pricing__title">Simple, Transparent Pricing</h1>
    <p class="pricing__subtitle">
      Start free. Upgrade when you're ready. Cancel anytime.
    </p>

    <!-- ── Billing toggle ──────────────── -->
    <div class="pricing__toggle-wrap">
      <span class="pricing__toggle-label"
            [class.pricing__toggle-label--active]="billingCycle === BillingCycle.Monthly">
        Monthly
      </span>
      <button class="pricing__toggle"
              (click)="billingCycle = billingCycle === BillingCycle.Monthly
                ? BillingCycle.Annual : BillingCycle.Monthly">
        <span class="pricing__toggle-knob"
              [class.pricing__toggle-knob--on]="billingCycle === BillingCycle.Annual">
        </span>
      </button>
      <span class="pricing__toggle-label"
            [class.pricing__toggle-label--active]="billingCycle === BillingCycle.Annual">
        Annual
        <span class="pricing__save-badge">Save 2 months</span>
      </span>
    </div>
  </div>

  <!-- ── Loading ─────────────────────── -->
  <div class="pricing__loading" *ngIf="loading">
    <div class="pricing__spinner"></div>
  </div>

  <!-- ── Trial CTA (shown to non-logged-in users) ── -->
  <div class="pricing__trial-banner" *ngIf="!isLoggedIn && !loading">
    <div class="pricing__trial-inner">
      <span class="pricing__trial-icon">🚀</span>
      <div>
        <p class="pricing__trial-title">Start your 14-day free trial</p>
        <p class="pricing__trial-desc">
          Get full Professional plan access — no credit card required.
          AI Insights included with a 20-insight allowance during trial.
        </p>
      </div>
      <a routerLink="/auth/register-company" class="pricing__trial-btn">
        Start Free Trial
      </a>
    </div>
  </div>

  <!-- ── Free plan strip ─────────────────────────── -->
  <div class="pricing__free-strip" *ngIf="!loading">
    <div class="pricing__free-left">
      <span class="pricing__free-badge">FREE</span>
      <div>
        <p class="pricing__free-title">Always free, no time limit</p>
        <p class="pricing__free-desc">
          3 workers · 5 jobs · Basic GPS · PDF with watermark · No AI access
        </p>
      </div>
    </div>
    <a routerLink="/auth/register-company"
       class="pricing__free-btn"
       *ngIf="!isLoggedIn">
      Start Free
    </a>
    <span class="pricing__current-badge"
          *ngIf="isLoggedIn && currentPlan === 'Free'">
      Current Plan
    </span>
  </div>

  <!-- ── Plan Cards ────────────────────────────────── -->
  <div class="pricing__cards" *ngIf="!loading">

    <div class="pricing__card"
         *ngFor="let plan of plans"
         [class.pricing__card--popular]="isPopular(plan.plan)"
         [class.pricing__card--current]="isCurrentPlan(plan.plan)">

      <div class="pricing__popular-badge" *ngIf="isPopular(plan.plan)">
        Most Popular
      </div>

      <div class="pricing__plan-name">{{ plan.plan }}</div>

      <div class="pricing__price-wrap">
        <span class="pricing__currency">$</span>
        <span class="pricing__price">{{ getMonthlyEquivalent(plan) }}</span>
        <span class="pricing__period">/mo</span>
      </div>

      <p class="pricing__annual-note"
         *ngIf="billingCycle === BillingCycle.Annual">
        Billed ${{ plan.priceAnnual }}/year
        <span class="pricing__saving">Save ${{ plan.annualSaving }}</span>
      </p>
      <p class="pricing__annual-note" *ngIf="billingCycle === BillingCycle.Monthly">&nbsp;</p>

      <div class="pricing__divider"></div>

      <ul class="pricing__features">
        <li class="pricing__feature">
          <span class="pricing__feature-icon pricing__feature-icon--yes">✓</span>
          <span>
          {{ plan.limits.maxWorkers === -1
  ? 'Unlimited workers'
  : plan.limits.maxWorkers + ' workers' }}
          </span>
        </li>
        <li class="pricing__feature">
          <span class="pricing__feature-icon pricing__feature-icon--yes">✓</span>
          <span>
         {{ plan.limits.maxActiveJobs === -1
  ? 'Unlimited jobs'
  : 'Up to ' + plan.limits.maxActiveJobs + ' jobs' }}
          </span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasLiveMap">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasLiveMap"
                [class.pricing__feature-icon--no]="!plan.limits.hasLiveMap">
            {{ plan.limits.hasLiveMap ? '✓' : '✗' }}
          </span>
          <span>Live Map</span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasExcelExport">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasExcelExport"
                [class.pricing__feature-icon--no]="!plan.limits.hasExcelExport">
            {{ plan.limits.hasExcelExport ? '✓' : '✗' }}
          </span>
          <span>Excel Export</span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="plan.limits.hasPdfWatermark">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="!plan.limits.hasPdfWatermark"
                [class.pricing__feature-icon--no]="plan.limits.hasPdfWatermark">
            {{ !plan.limits.hasPdfWatermark ? '✓' : '✗' }}
          </span>
          <span>PDF without watermark</span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasBrandedPdf">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasBrandedPdf"
                [class.pricing__feature-icon--no]="!plan.limits.hasBrandedPdf">
            {{ plan.limits.hasBrandedPdf ? '✓' : '✗' }}
          </span>
          <span>Company Branding on PDF</span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasReports">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasReports"
                [class.pricing__feature-icon--no]="!plan.limits.hasReports">
            {{ plan.limits.hasReports ? '✓' : '✗' }}
          </span>
          <span>Reports &amp; Analytics</span>
        </li>
        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasNotifications">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasNotifications"
                [class.pricing__feature-icon--no]="!plan.limits.hasNotifications">
            {{ plan.limits.hasNotifications ? '✓' : '✗' }}
          </span>
          <span>In-app Notifications</span>
        </li>

        <!-- AI Insights row — highlighted for plans that include it -->
        <li class="pricing__feature pricing__feature--ai"
            [class.pricing__feature--no]="!plan.limits.hasAiInsights">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasAiInsights"
                [class.pricing__feature-icon--no]="!plan.limits.hasAiInsights">
            {{ plan.limits.hasAiInsights ? '✓' : '✗' }}
          </span>
          <span>
            <strong>Predictive Operational Intelligence</strong>
            <span class="pricing__ai-label" *ngIf="plan.limits.hasAiInsights">
              {{ plan.aiLabel }}
            </span>
          </span>
        </li>

        <li class="pricing__feature"
            [class.pricing__feature--no]="!plan.limits.hasComplianceExport">
          <span class="pricing__feature-icon"
                [class.pricing__feature-icon--yes]="plan.limits.hasComplianceExport"
                [class.pricing__feature-icon--no]="!plan.limits.hasComplianceExport">
            {{ plan.limits.hasComplianceExport ? '✓' : '✗' }}
          </span>
          <span>NUPRC/OSHA Compliance Export</span>
        </li>

        <li class="pricing__feature">
          <span class="pricing__feature-icon pricing__feature-icon--yes">✓</span>
          <span>{{ plan.limits.supportLevel }} support</span>
        </li>
      </ul>

      <button
        class="pricing__cta"
        [class.pricing__cta--current]="isCurrentPlan(plan.plan)"
        [class.pricing__cta--popular]="isPopular(plan.plan) && !isCurrentPlan(plan.plan)"
        [disabled]="isCurrentPlan(plan.plan) || processingPlan === plan.plan"
        (click)="selectPlan(plan)">
        <span class="pricing__btn-spinner" *ngIf="processingPlan === plan.plan"></span>
        {{ isCurrentPlan(plan.plan) ? 'Current Plan'
           : processingPlan === plan.plan ? 'Processing…'
           : 'Upgrade to ' + plan.plan }}
      </button>

    </div>
    <p class="pricing__contact-note">
  Questions about pricing or need a custom plan?
  <a routerLink="/contact">Talk to our team →</a>
</p>
  </div>
</div>
